import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {AppService} from '../app.service';
import {ZalozkaObsah} from '../model/zalozkaObsah';
import {Location} from '@angular/common';

@Component({
  selector: 'app-zalozka-obsah',
  templateUrl: './zalozka-obsah.component.html',
  styleUrls: ['./zalozka-obsah.component.css']
})
export class ZalozkaObsahComponent implements OnInit {

  obsah: ZalozkaObsah[];

  loading = true;

  constructor(
    private route: ActivatedRoute,
    private appService: AppService,
    private location: Location,
  ) { }

  ngOnInit(): void {
    window.scrollTo(0, 0);
    this.loading = true;

    this.route.params.subscribe(val => {
      this.appService
        .fetchZalozka(val.id)
        .subscribe(data => {
          this.obsah = data;
          this.loading = false;
        });
    });
  }

  goBack() {
    this.location.back();
  }
}
